import { z } from "zod";
export const organizationKind = z.enum(["internal", "external"]);
export const createOrganizationInput = z.object({
    name: z.string().trim().min(1).max(160),
    kind: organizationKind.default("external"),
});
export const renameOrganizationInput = z.object({
    name: z.string().trim().min(1).max(160),
});
export const organizationSummary = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    kind: organizationKind,
    memberCount: z.number().int(),
    studyCount: z.number().int(),
});
/** Sin paginar a propósito: son decenas, no miles. */
export const organizationList = z.object({ items: z.array(organizationSummary) });
/**
 * Slug de la organización interna que el sistema garantiza siempre.
 *
 * Vive aquí y no en `apps/api` porque `apps/web` la necesita y no depende de
 * la API. Y es un slug, no `kind === "internal"`: el diseño §3.1 define «la
 * organización interna» por slug precisamente porque un administrador puede
 * crear más internas, y entonces buscar por `kind` devolvería la primera por
 * orden alfabético — una respuesta equivocada, silenciosa y no determinista.
 */
export const INTERNAL_ORG_SLUG = "ir-adviser";
//# sourceMappingURL=organization.js.map